import { Box, Button, TextareaAutosize } from "@mui/material";
import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Common/CommonDynamicTable";
import styles from "../../../../styles/brsr/general.module.css";
import ReusableTable from "../../../Common/ReusableTable";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { get, put } from "../../../../utils/api";
import style from "../../../../styles/brsr/general.module.css";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import DeleteRowDialog from "../../../Common/DeleteRowDialog";
import BRSRFile from "../../../Common/BRSRFile";
import EastIcon from "@mui/icons-material/East";

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({ index: null, table: null });
  const [modalupload, setModalUpload] = useState({
    socialImpactAssessmentsDoc: false,
    rehabilitationAndResettlementDoc: false,
    communityGrievanceMechanismsDoc: false,
    sourceFromSupplierDoc: false,
    jobCreationInSmallerTownsDoc: false,
  });
  const [formData, setFormData] = useState({
    socialImpactAssessments: [
      {
        // serialNumber: 1,
        projectName: "",
        // details: "",
        SIANotificationNo: "",
        dateOfNotification: "",
        conductedByExternalAgency: "",
        resultsCommunicatedPublicDomain: "",
        webLink: "",
      },
    ],
    rehabilitationAndResettlement: [
      {
        // serialNumber: 1,
        projectName: "",
        state: "",
        district: "",
        numberOfProjectAffectedFamilies: "",
        percentagePAFsCoveredByRR: "",
        amountsPaidToPAFs: "",
      },
    ],
    communityGrievanceMechanisms: "",
    sourceFromSupplier: {
      smallProducers: { currentFinacialYear: "", previousFinancialYear: "" },
      neighbouringDistricts: {
        currentFinacialYear: "",
        previousFinancialYear: "",
      },
    },
    jobCreationInSmallerTowns: {
      rural: { currentFinacialYear: "", previousFinancialYear: "" },
      semiUrban: { currentFinacialYear: "", previousFinancialYear: "" },
      urban: { currentFinacialYear: "", previousFinancialYear: "" },
      metropolitan: { currentFinacialYear: "", previousFinancialYear: "" },
    },
    socialImpactAssessmentsDoc: [],
    rehabilitationAndResettlementDoc: [],
    communityGrievanceMechanismsDoc: [],
    sourceFromSupplierDoc: [],
    jobCreationInSmallerTownsDoc: [],
  });
  const [rows, setRows] = useState("");
  const [errors, setErrors] = useState([]);

  const handleDeleteClick = (rowIndex, tableField) => {
    const rowData = formData[tableField][rowIndex];

    // Ignore serialNumber when checking for filled data
    const hasData = Object.entries(rowData).some(
      ([key, val]) =>
        key !== "serialNumber" && val !== "" && val !== null && val !== false
    );

    if (hasData) {
      setRowToDelete({ index: rowIndex, table: tableField });
      setOpenDialog(true);
    } else {
      // If only serialNumber is filled or all fields are empty, delete directly
      deleteRow(rowIndex, tableField);
    }
  };

  const deleteRow = (rowIndex, tableField) => {
    setFormData((prev) => {
      const updatedTable = [...prev[tableField]];
      updatedTable.splice(rowIndex, 1);
      const updatedTableWithSerialNumbers = updatedTable.map((row, index) => ({
        ...row,
        serialNumber: index + 1,
      }));
      return { ...prev, [tableField]: updatedTableWithSerialNumbers };
    });
  };

  const confirmDelete = () => {
    if (rowToDelete.index !== null && rowToDelete.table) {
      deleteRow(rowToDelete.index, rowToDelete.table);
    }
    setOpenDialog(false);
    setRowToDelete({ index: null, table: null });
  };

  const cancelDelete = () => {
    setOpenDialog(false);
    setRowToDelete({ index: null, table: null });
  };

  const validateForm = () => {
    let newErrors = {};

    // ✅ Check if formData exists to avoid undefined errors
    if (!formData) return false;
    formData.socialImpactAssessments.forEach((assessment, rowIndex) => {
      Object.entries(assessment).forEach(([key, value]) => {
        if (value === "" || value === null) {
          if (!newErrors.socialImpactAssessments)
            newErrors.socialImpactAssessments = [];
          newErrors.socialImpactAssessments[rowIndex] = {
            ...(newErrors.socialImpactAssessments[rowIndex] || {}),
            [key]: ` ${key}`, // ✅ Includes Row Number
            // [key]: `Row ${rowIndex + 1}: ${key}`,
          };
        }
      });
    });

    // ✅ Validate `rehabilitationAndResettlement`
    formData.rehabilitationAndResettlement.forEach((assessment, rowIndex) => {
      Object.entries(assessment).forEach(([key, value]) => {
        if (value === "" || value === null) {
          if (!newErrors.rehabilitationAndResettlement)
            newErrors.rehabilitationAndResettlement = [];
          newErrors.rehabilitationAndResettlement[rowIndex] = {
            ...(newErrors.rehabilitationAndResettlement[rowIndex] || {}),
            [key]: ` ${key}`, // ✅ Includes Row Number
            // [key]: `Row ${rowIndex + 1}: ${key}`,
          };
        }
      });
    });

    // ✅ Validate `communityGrievanceMechanisms`
    if (formData.communityGrievanceMechanisms === "") {
      newErrors.communityGrievanceMechanisms = "This field is required";
    }

    // ✅ Validate `sourceFromSupplier`
    newErrors.sourceFromSupplier = validateNestedObject(
      formData.sourceFromSupplier
    );

    // ✅ Validate `jobCreationInSmallerTowns`
    // newErrors.jobCreationInSmallerTowns = validateNestedObject(
    //   formData.jobCreationInSmallerTowns
    // );

    // ✅ Remove empty error objects
    newErrors = Object.fromEntries(
      Object.entries(newErrors).filter(
        ([_, value]) => value && Object.keys(value).length > 0
      )
    );

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Helper function to validate nested objects like `sourceFromSupplier` & `jobCreationInSmallerTowns`
  const validateNestedObject = (data) => {
    let errors = {};

    if (!data || typeof data !== "object") return errors;

    Object.keys(data).forEach((location, rowIndex) => {
      const jobData = data[location] || {}; // ✅ Prevents null/undefined errors
      let missingFields = [];

      if (!errors[location]) errors[location] = {};

      console.log("ent1", Object.entries(jobData));
      Object.entries(jobData).forEach(([field, value]) => {
        if (value === "" || value === null) {
          missingFields.push(field);
          errors[location][field] = `${field} is required`;
        }
      });

      if (missingFields.length > 0) {
        errors[location]["errorSummary"] = `Row ${
          rowIndex + 1
        }: Missing fields - ${missingFields.join(", ")}`;
      }

      // ✅ Remove location if it's an empty object
      if (Object.keys(errors[location]).length === 0) {
        delete errors[location];
      }
    });

    // setErrors(errors);
    console.log(errors, "err1", data);
    return errors;
  };

  const fetchData = async () => {
    const res = await get(
      `/brsr/get?subType=principle8&type=SectionC&id=${id}`
    );

    const res1 = res?.data?.data?.BRSRSectionC?.principle8?.essentialIndicators;
    if (
      res?.data?.data?.year
        ? res?.data?.data?.year < currentYear - 1
        : false || !brsrReview
    )
      setDisabled(true);

    setFormData((prev) => ({
      ...prev,
      ...res1,
      socialImpactAssessments:
        res1?.socialImpactAssessments?.length > 0
          ? res1?.socialImpactAssessments
          : prev?.socialImpactAssessments,
      rehabilitationAndResettlement:
        res1?.rehabilitationAndResettlement?.length > 0
          ? res1?.rehabilitationAndResettlement
          : prev?.rehabilitationAndResettlement,
      socialImpactAssessmentsDoc: res1?.socialImpactAssessmentsDoc || [],
      rehabilitationAndResettlementDoc:
        res1?.rehabilitationAndResettlementDoc || [],
      communityGrievanceMechanismsDoc:
        res1?.communityGrievanceMechanismsDoc || [],
      sourceFromSupplierDoc: res1?.sourceFromSupplierDoc || [],
      jobCreationInSmallerTownsDoc: res1?.jobCreationInSmallerTownsDoc || [],
    }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTableChange = (tableField, rowIndex, key, value, type) => {
    if (type === "number" && !/^\d*$/.test(value)) return;

    // if ( type === "percentage" &&
    //   !/^\d*$/.test(value) &&
    //   (Number(value) < 0 || Number(value) > 100)
    // ) return;
    if (type === "percentage") {
      // Allow only numbers and optional decimals
      if (!/^\d*\.?\d*$/.test(value)) return;

      // Convert value to a number and restrict range
      if (Number(value) < 0 || Number(value) > 100) return;
    }
    if (type === "date") {
    }
    setFormData((prevState) => {
      const updatedTable = [...prevState[tableField]];
      updatedTable[rowIndex] = { ...updatedTable[rowIndex], [key]: value };
      return { ...prevState, [tableField]: updatedTable };
    });
    if (value !== "" && value !== null) {
      clearCellError(tableField, rowIndex, key);
    }
  };

  const addRowToTable = (tableField, defaultRow) => {
    setFormData((prevState) => ({
      ...prevState,
      [tableField]: [...prevState[tableField], defaultRow],
    }));
  };

  const socialImpactColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    {
      label: "Name and brief details of project",
      field: "projectName",
      type: "text",
    },
    { label: "SIA Notification No.", field: "SIANotificationNo", type: "text" },
    {
      label: `Date of notification, dd/mm/yyyy`,
      field: "dateOfNotification",
      type: "date",
    },
    {
      label: "Whether conducted by independent external agency . (Yes / No)",
      field: "conductedByExternalAgency",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      label: "Results communicated in public domain (Yes / No)",
      field: "resultsCommunicatedPublicDomain",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    { label: "Relevant Web link", field: "webLink", type: "text" },
  ];

  const rehabilitationColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    { label: "Project Name", field: "projectName", type: "text" },
    { label: "State", field: "state", type: "text" },
    { label: "District", field: "district", type: "text" },
    {
      label: "No. of Project Affected Families (PAFs)",
      field: "numberOfProjectAffectedFamilies",
      type: "number",
    },
    {
      label: "% of PAFs Covered by R&R",
      field: "percentagePAFsCoveredByRR",
      type: "percentage",
    },
    {
      label: "Amounts Paid to PAFs",
      field: "amountsPaidToPAFs",
      type: "number",
    },
  ];

  /* EssentialIndicator.jsx */

  const clearCellError = (tableField, rowKey, columnKey) => {
    setErrors((prev) => {
      const list = ["rural", "semiUrban", "urban", "metropolitan"];
      const list2 = ["smallProducers", "neighbouringDistricts"];

      // Determine the actual rowKey or its index if it exists in the lists
      let rowIndex = rowKey;
      if (list.includes(rowKey)) {
        rowIndex = list.indexOf(rowKey);
      } else if (list2.includes(rowKey)) {
        rowIndex = list2.indexOf(rowKey);
      }

      if (!prev?.[tableField]?.[rowKey]?.[columnKey]) return prev;

      const copy = JSON.parse(JSON.stringify(prev)); // Deep clone

      // Remove the specific field error
      delete copy[tableField][rowKey][columnKey];

      const row = copy[tableField][rowKey];

      // Update errorSummary if it exists
      if (row?.errorSummary) {
        let summary = row.errorSummary;

        // Extract fields from the summary string
        let fields = summary
          .replace(`Row ${rowIndex + 1}: Missing fields -`, "")
          .split(",")
          .map((f) => f.trim());

        // Remove the current columnKey from the list
        fields = fields.filter((f) => f !== columnKey);

        if (fields.length === 0) {
          delete copy[tableField][rowKey]["errorSummary"];
        } else {
          copy[tableField][rowKey]["errorSummary"] =
            `Row ${rowIndex + 1}: Missing fields -` + fields.join(", ");
        }
      }

      // If no more errors in the row, delete the row
      if (Object.keys(copy[tableField][rowKey]).length === 0) {
        delete copy[tableField][rowKey];
      }

      // If no more errors in the table, delete the tableField
      if (Object.keys(copy[tableField]).length === 0) {
        delete copy[tableField];
      }

      return copy;
    });
  };

  const handleChange = (section, type, key, field, value) => {
    console.log(type, value, "checking value type and value");
    if (type === "percentage") {
      if (
        !/^\d*\.?\d*$/.test(value) ||
        Number(value) < 0 ||
        Number(value) > 100
      )
        return;
    }
    if (type === "number") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: {
          ...prev[section][key],
          [field]:
            type === "percentage" || type === "number" ? Number(value) : value,
        },
      },
    }));
    // 2. clear the corresponding error if the new value is valid
    if (value !== "" && value !== null) {
      clearCellError(section, key, field);
    }
  };

  // Table configurations
  const supplierRows = [
    {
      label: "Directly sourced from MSMEs/ small producers",
      key: "smallProducers",
    },
    {
      label:
        "Sourced directly from within the district and neighbouring districts",
      key: "neighbouringDistricts",
    },
  ].map((item) => ({
    Location: item.label,
    currentFinacialYear:
      formData.sourceFromSupplier[item.key].currentFinacialYear,
    previousFinancialYear:
      formData.sourceFromSupplier[item.key].previousFinancialYear,
  }));

  const jobRows = ["rural", "semiUrban", "urban", "metropolitan"].map(
    (key) => ({
      Location:
        key === "semiUrban"
          ? "Semi-urban"
          : key.charAt(0).toUpperCase() + key.slice(1),
      currentFinacialYear:
        formData.jobCreationInSmallerTowns[key].currentFinacialYear,
      previousFinancialYear:
        formData.jobCreationInSmallerTowns[key].previousFinancialYear,
    })
  );

  const columns = [
    { label: "Location", field: "Location", type: "disabled" },
    {
      label: "Current financial year",
      field: "currentFinacialYear",
      type: "number",
    },
    {
      label: "Previous financial year",
      field: "previousFinancialYear",
      type: "number",
    },
  ];

  console.log("formdata", formData);
  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) {
        return; // ✅ Stop submission if validation fails
      }
      const payload = {
        essentialIndicators: {
          ...formData,
        },
        essentialIndicatorsSubmitted: true,
        type: "SectionC",
        subType: "principle8",
      };
      await put(`/brsr/update?id=${id}`, payload)
        .then((res) => onSave())
        .catch((err) => {});
    } else onSave();
  };
  return (
    <>
      <DeleteRowDialog
        openDialog={openDialog}
        cancelRemoveRow={cancelDelete}
        confirmRemoveRow={confirmDelete}
      />
      <Box>
        {/* 1. Social Impact Assessments */}
        <p className={style.subHeading}>I. ESSENTIAL INDICATOR</p>
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            1. Details of Social Impact Assessments (SIA) of projects undertaken
            by the entity based on applicable laws, in the current financial
            year.
          </p>
          <Box sx={{ ml: 2 }}>
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.socialImpactAssessments}
              columns={socialImpactColumns}
              setRows={setRows}
              errors={errors?.socialImpactAssessments}
              // onDeleteRow={handleRemoveSocialImpactRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(rowIndex, "socialImpactAssessments")
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "socialImpactAssessments",
                  rowIndex,
                  key,
                  value,
                  type
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable("socialImpactAssessments", defaultRow)
              }
              defaultRow={{
                serialNumber: formData.socialImpactAssessments.length + 1,
                projectName: "",
                // details: "",
                SIANotificationNo: "",
                dateOfNotification: "",
                conductedByExternalAgency: false,
                resultsCommunicatedPublicDomain: false,
                webLink: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "socialImpactAssessmentsDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {/* 2. Rehabilitation and Resettlement */}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            2. Provide information on project(s) for which ongoing
            Rehabilitation and Resettlement (R&R) is being undertaken by your
            entity, in the following format:
          </p>
          <Box sx={{ ml: 2 }}>
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.rehabilitationAndResettlement}
              columns={rehabilitationColumns}
              setRows={setRows}
              errors={errors?.rehabilitationAndResettlement}
              // onDeleteRow={handleRemoveRow}
              // onDeleteRow={handleRemoveRehabilitationRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(rowIndex, "rehabilitationAndResettlement")
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "rehabilitationAndResettlement",
                  rowIndex,
                  key,
                  value,
                  type
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable("rehabilitationAndResettlement", defaultRow)
              }
              defaultRow={{
                serialNumber: formData.rehabilitationAndResettlement.length + 1,
                projectName: "",
                state: "",
                district: "",
                numberOfProjectAffectedFamilies: "",
                percentagePAFsCoveredByRR: "",
                amountsPaidToPAFs: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "rehabilitationAndResettlementDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {/* 3. Community Grievance Mechanisms */}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            3. Describe the mechanisms to receive and redress grievances of the
            community.
          </p>
          <TextareaAutosize
            disabled={disabled}
            minRows={3}
            style={{
              width: "98%",
              padding: "8px",
              background: "transparent",
              border: "1px solid #74757E",
              borderRadius: "4px",
              marginLeft: "1rem",
            }}
            error={!!(errors["communityGrievanceMechanisms"] && true)}
            placeholder="Type Here"
            value={formData.communityGrievanceMechanisms}
            onChange={(e) =>
              setFormData({
                ...formData,
                communityGrievanceMechanisms: e.target.value,
              })
            }
            InputLabelProps={{
              style: {
                color: errors["communityGrievanceMechanisms"]
                  ? "#D34040"
                  : undefined,
              },
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              // marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
              marginLeft: "15px",
            }}
          >
            {errors["communityGrievanceMechanisms"]}
          </p>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "communityGrievanceMechanismsDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        {/* 4. Percentage of input material (inputs to total inputs by value) sourced from suppliers: */}
        <Box>
          <ReusableTable
            disabled={disabled}
            title="4. Percentage of input material (inputs to total inputs by value) sourced from suppliers:"
            rows={supplierRows}
            columns={columns}
            data={formData.sourceFromSupplier}
            errors={errors?.sourceFromSupplier}
            setRows={setRows}
            // errors={errors?.sourceFromSupplier}

            onChange={(rowIndex, type, field, value) =>
              handleChange(
                "sourceFromSupplier",
                (type = "percentage"),
                Object.keys(formData.sourceFromSupplier)[rowIndex],
                field,
                value
              )
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "sourceFromSupplierDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {/* 5. Job creation in smaller towns */}
        {/* <Box>
          <p className={styles.question_title}>
            5. Job creation in smaller towns – Disclose wages paid to persons
            employed (including employees or workers employed on a permanent or
            non-permanent / on contract basis) in the following locations, as %
            of total wage cost:
          </p>
          <ReusableTable
            disabled={disabled}
            // title="5. Job creation in smaller towns – Disclose wages paid to persons employed (including employees or workers employed on a permanent or non-permanent / on contract basis) in the following locations, as % of total wage cost:"
            rows={jobRows}
            columns={columns}
            data={formData.jobCreationInSmallerTowns}
            errors={errors?.jobCreationInSmallerTowns}
            setRows={setRows}
            onChange={(rowIndex, type, field, value) =>
              handleChange(
                "jobCreationInSmallerTowns",
                (type = "percentage"),
                ["rural", "semiUrban", "urban", "metropolitan"][rowIndex],
                field,
                value
              )
            }
          />
        </Box> */}
        {/* <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "jobCreationInSmallerTownsDoc",
            ml: 2,
            removeUpload,
          }}
        /> */}
        {!hide && (
          <>
            {brsrReview ? (
              <Box sx={{ width: "98.5%", ml: 2 }}>
                <ReviewBox
                  url={`/brsr/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default EssentialIndicator;
